<template>
  <div @click="jump" class="history-bth">
    <span v-if="type == 1"
      >{{ $t("message.strid47") }}</span
    >
    <span v-if="type == 2">{{ $t("message.strid49") }}</span>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    type: {
      default: 1
    }
  },
  computed: {
    ...mapState(["_history"]),
  },
  methods: {
    jump(type) {
      if (this.type == 1) {
        this.$router.push({ name: "search" });
      } else if (this.type == 2) {
        if (this._history.length == 0||!this._history.length) {
          this.$router.replace({ name: "law" });
        } else {
          this.$router.go(-1);
        }
      }
    }
  }
};
</script>

<style lang="scss">
@media screen and (min-width: $mimViewWidth) {
  @import "@/assets/scss/components/History.scss";
}
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/components/m/History.scss";
}
</style>
